// lib/slides/proposalSheetLayout.ts
import type { PageRegion } from './counterProposal';
import { cornerStampFrame } from './annotationLayout';

/** Contain the complete image between the export stamp and the branded footer. */
export function proposalSheetLayout(width: number, height: number): {
  image: PageRegion; cartouche: PageRegion;
} {
  if (![width, height].every((n) => Number.isFinite(n) && n > 0)) {
    throw new Error('Invalid proposal page dimensions');
  }
  const margin = Math.min(width, height) * 0.025;
  const footerHeight = Math.min(width * 140 / 1200, height * 0.25);
  const stamp = cornerStampFrame(width, height);
  const imageY = stamp.y + stamp.h + margin;
  const imageHeight = height - footerHeight - margin - imageY;
  if (imageHeight <= 0) throw new Error('Proposal page is too short for the review stamp and cartouche');
  return {
    image: { x: margin, y: imageY, w: width - margin * 2, h: imageHeight },
    cartouche: { x: 0, y: height - footerHeight, w: width, h: footerHeight },
  };
}
